import { Component, ElementRef, Input, OnInit, Renderer2, ViewChild } from '@angular/core';

@Component({
    selector: 'list-tooltip',
    templateUrl: './list-tooltip.component.html',
    styleUrls: ['./list-tooltip.component.scss'],
})
export class ListTooltipComponent implements OnInit {

    @Input('data') data: string[];
    public Data: string;
    @Input() Position: 'top' | 'bottom' | 'left' | 'right' = 'bottom';

    @ViewChild('trigger') triggerRef!: ElementRef<HTMLElement>;
    @ViewChild('tooltip') tooltipRef!: ElementRef<HTMLElement>;

    IsVisible = false;
    ArrowStyle: any = {};

    constructor(private renderer: Renderer2) { }

    ngOnInit() {
        this.UpdateArrowPosition();

        this.Data = this.data?.length > 0 ? this.data.join(", ") : '';
    }

    ShowTooltip() {

        if (!this.Data.length) return;

        this.IsVisible = true;

        this.UpdateArrowPosition();
        // Pequeno delay para garantir renderização antes de mostrar
        const t = setTimeout(() => {
            clearTimeout(t);
            if (this.tooltipRef?.nativeElement) {
                this.renderer.addClass(this.tooltipRef.nativeElement, 'visible');
            }
        }, 10);
    }

    HideTooltip() {
        if (this.tooltipRef?.nativeElement) {
            this.renderer.removeClass(this.tooltipRef.nativeElement, 'visible');
        }
        const t = setTimeout(() => {
            clearTimeout(t);
            this.IsVisible = false;
        }, 200); // sincronizado com transition
    }

    UpdateArrowPosition() {
        if (!this.triggerRef?.nativeElement || !this.tooltipRef?.nativeElement) return;

        const triggerRect = this.triggerRef.nativeElement.getBoundingClientRect();
        const tooltipRect = this.tooltipRef.nativeElement.getBoundingClientRect();

        console.log(tooltipRect.width, (triggerRect.width / 2 - 4));

        // Ajuste da seta para centralizar
        // switch (this.Position) {
        //     case 'top':
        //         this.ArrowStyle.left = `${triggerRect.width / 2 - 4}px`;
        //         break;
        //     case 'bottom':
        //         this.ArrowStyle.left = `${triggerRect.width / 2 - 4}px`;
        //         break;
        //     case 'left':
        //         this.ArrowStyle.top = `${triggerRect.height / 2 - 4}px`;
        //         break;
        //     case 'right':
        //         this.ArrowStyle.top = `${triggerRect.height / 2 - 4}px`;
        //         break;
        // }
    }

    ngOnDestroy() {
        // Limpeza opcional
    }

}
